import { atom } from 'jotai';

const _relatedPostShownPostCursor = atom(0);

export const $RelatedPostShownPostCursor = atom(
  (get) => get(_relatedPostShownPostCursor),
  (get, set, input: number) => {
    if (input < 0) {
      // when the postCursor is reset
      set(_relatedPostShownPostCursor, 0);
    } else {
      set(_relatedPostShownPostCursor, Math.max(get(_relatedPostShownPostCursor), input));
    }
  },
);

export const RELATED_POST_SHOWN_POST_BIAS = 2;
